import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Icon, IconButton, Grid, TextField, Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../store/actions';
import DraggableExpansionPanel from '../../../components/dragAndDrop/DraggableExpansionPanel';
import UnscheduledCourseOrder from './UnscheduledCourseOrder';
import WizardLessonList from './WizardLessonList';
import UnscheduledCourseLessonContainer from './UnscheduledCourseLessonContainer';

const styles = theme => ({
    root: {
        width: '90%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    backButton: {
        marginRight: theme.spacing.unit,
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
});

class BlankUnscheduledCourse extends React.Component {

    constructor(props) {
        super(props);
        this.props.getAllLessons(props.auth.user.data.auth_id)
    }

    handleAddNewClick = () => {
        this.props.toggleLessonDialog(true, null, true)
        this.props.lessonDialogChoice('create')
    }

    state = { lessonSearch: '' }

    render() {
        return (
            <div style={{ padding: '10px' }}>
                <Grid container spacing={8}>
                    <Grid item xs={7}>

                        {this.props.match.params.view_type === 'edit' ? null :
                            <Button
                                onClick={() => this.handleAddNewClick()}
                                variant={'contained'}
                            >
                                Add New Lesson
                            </Button>
                        }

                        <WizardLessonList
                            lessonList={this.props.allLessons.filter(lesson => lesson.Unscheduled === 1)}
                            Unscheduled={true}
                            mappedLessons={this.props.mappedLessons}
                        />

                    </Grid>
                    <Grid item xs={5}>
                        {/* <UnscheduledCourseOrder
                            moveUnscheduledLesson={this.props.moveUnscheduledLesson}
                            pushUnscheduledLesson={this.props.pushUnscheduledLesson}
                            handleUnscheduledLessonDelete={this.props.handleUnscheduledLessonDelete}
                            selectedLessons={this.props.mappedLessons}
                        /> */}
                        <UnscheduledCourseLessonContainer
                            // moveUnscheduledLesson={this.props.moveUnscheduledLesson}
                            // pushUnscheduledLesson={this.props.pushUnscheduledLesson}
                            handleDelete={this.props.handleUnscheduledLessonDelete}
                            selectedLessons={this.props.mappedLessons}
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAllLessons: Actions.getAllLessons,
        toggleLessonDialog: Actions.toggleLessonDialog,
        lessonDialogChoice: Actions.lessonDialogChoice
        // pushUnscheduledLesson: Actions.pushUnscheduledLesson,
        // moveUnscheduledLesson: Actions.moveUnscheduledLesson
    }, dispatch);
}

function mapStateToProps({ validator, courseApp, auth }) {
    return {
        allLessons: courseApp.courses.allLessons,
        auth
        // mappedLessons: courseApp.courseBuilder.mappedLessons,
    }
}
export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(BlankUnscheduledCourse)));


// WEBPACK FOOTER //
// src/main/content/course/builderComponents/BlankUnscheduledCourse.js